angular.module( 'acme.view.application.membership.categories.create.email', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.categories.create.email.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipCategoriesCreateEmail = {
    name: 'application.membership.categories.create.email',
    url: '/email',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateEmailController',
        // Assumes the view is entirely self contained
        templateUrl: 'views/application/views/membership/categories/create/email/email.tpl.html'
      }
    },
    data: {
      pageTitle: 'Create Membership Level'
    }
  },
  membershipCategoriesEditEmail = {
    name: 'application.membership.categories.edit.email',
    url: '/email',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateEmailController',
        // Assumes the view is entirely self contained
        templateUrl: 'views/application/views/membership/categories/create/email/email.tpl.html'
      }
    },
    data: {
      pageTitle: 'Edit Membership Level'
    }
  };

    $stateProvider
      .state(membershipCategoriesCreateEmail)
      .state(membershipCategoriesEditEmail);
});
